(() => {
  if (customElements.get('dod-product-bundles')) return;
  class ProductBundles extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.config = JSON.parse(this.querySelector('[data-bundle-config]').textContent);
      this.copy = this.config.copy;
      this.games = new Map([...this.querySelectorAll('[data-bundle-game]')].map(template => [template.dataset.bundleGame, {
        id: template.dataset.bundleGame, title: template.dataset.title,
        variant: Number(template.dataset.variant), price: Number(template.dataset.price),
        available: template.dataset.available === 'true', template
      }]));
      this.selection = this.config.defaults.filter(id => this.games.has(String(id))).slice(0,4).map(String);
      this.current = this.games.get(this.dataset.currentId);
      if (!this.current || this.selection.length < 2) { this.hidden = true; return; }
      this.count = Math.min(Number(this.dataset.count),this.selection.length);
      this.formatter = new Intl.NumberFormat(this.dataset.locale || 'en-US',{style:'currency',currency:this.dataset.currency || 'USD'});
      this.submit = this.querySelector('[data-bundle-submit]');
      this.status = this.querySelector('[data-bundle-status]');
      this.dialog = this.querySelector('dialog');
      this.root = this.closest('[data-quick-buy]');
      this.options = [...this.querySelectorAll('[data-bundle-option]')];
      this.querySelector('fieldset').addEventListener('change',event => {
        if (event.target.type !== 'radio') return;
        this.count = Number(event.target.value);
        this.status.textContent = '';
        this.render();
      });
      this.querySelectorAll('[data-bundle-swap]').forEach(button => button.addEventListener('click',() => {
        if (this.busy) return;
        this.lastFocus = button;
        this.pending = this.selection.slice(0,this.count);
        this.pending = this.selection.slice(0,this.count);
        this.renderSlots();
        this.dialog.showModal();
      }));
      this.querySelectorAll('[data-bundle-close]').forEach(button => button.addEventListener('click',() => this.dialog.close()));
      this.dialog.addEventListener('click',event => { if (event.target === this.dialog) this.dialog.close(); });
      this.dialog.addEventListener('close',() => this.lastFocus?.focus({preventScroll:true}));
      this.submit.addEventListener('click',() => this.addBundle());
      this.root?.querySelector('[data-qb-variant]')?.addEventListener('change',event => {
        const variant = this.config.variants.find(item => String(item.id) === event.target.value);
        if (!variant) return;
        this.current.variant = Number(variant.id);
        this.current.price = Number(variant.price);
        this.current.available = variant.available;
        this.render();
      });
      this.resize = new ResizeObserver(() => this.fitPacks());
      this.resize.observe(this);
      this.render();
    }
    disconnectedCallback() { this.resize?.disconnect(); }
    text(key,values={}) { return (this.copy[key] || '').replace(/__([a-z_]+)__/g,(_,name) => values[name] ?? ''); }
    money(cents) { return this.formatter.format(cents / 100); }
    totals(count) {
      const selected = this.selection.slice(0,count).map(id => this.games.get(id));
      return selected.reduce((sum,game) => {
        sum.original += game.price;
        sum.total += game.price - Math.floor(game.price * count / 10);
        return sum;
      },{original:0,total:0});
    }
    makePack(game) { return game.template.content.cloneNode(true); }
    fitPacks() {
      this.querySelectorAll('.dod-bundle__pack[data-bounds]').forEach(pack => {
        const image = pack.querySelector('img');
        if (!image || !pack.clientWidth || !pack.clientHeight) return;
        const [left,top,right,bottom,width,height] = pack.dataset.bounds.split(',').map(Number);
        const scale = Math.min(pack.clientWidth * .97 / (right-left),pack.clientHeight * .97 / (bottom-top));
        Object.assign(image.style,{width:width*scale+'px',height:height*scale+'px',left:((pack.clientWidth-(right-left)*scale)/2-left*scale)+'px',top:((pack.clientHeight-(bottom-top)*scale)/2-top*scale)+'px'});
      });
    }
    render() {
      this.options.forEach(option => {
        const count = Number(option.dataset.bundleOption);
        option.hidden = count > this.selection.length;
        if (option.hidden) return;
        const totals = this.totals(count);
        const selected = count === this.count;
        option.classList.toggle('is-selected',selected);
        option.querySelector('input').checked = selected;
        option.querySelector('[data-bundle-swap]').hidden = !selected;
        option.querySelector('[data-bundle-original]').textContent = this.money(totals.original);
        option.querySelector('[data-bundle-total]').textContent = this.money(totals.total);
        option.querySelector('[data-bundle-names]').textContent = count === 2 ? this.current.title + ' + ' + this.games.get(this.selection[1]).title : this.text('add_game',{game:this.games.get(this.selection[count-1]).title});
        const images = option.querySelector('[data-bundle-images]');
        images.replaceChildren(...this.selection.slice(0,count).map(id => this.makePack(this.games.get(id))));
      });
      const totals = this.totals(this.count);
      this.submit.textContent = this.busy ? this.text('adding') : this.text('add_bundle',{count:this.count,price:this.money(totals.total)});
      this.submit.disabled = this.busy || !this.current.available || this.needsCartCheck;
      this.querySelector('[data-bundle-saving]').textContent = this.text('saving',{amount:this.money(totals.original-totals.total)});
      this.fitPacks();
    }
    renderSlots() {
      const host = this.querySelector('[data-bundle-slots]');
      host.replaceChildren();
      const included = document.createElement('div'); included.className = 'dod-bundle__slot';
      included.append(this.makePack(this.current));
      const info = document.createElement('div');
      const note = document.createElement('span'); note.textContent = this.text('included');
      const title = document.createElement('strong'); title.textContent = this.current.title;
      info.append(note,title); included.append(info); host.append(included);
      const progress = document.createElement('p'); progress.className = 'dod-bundle__pick-status'; progress.setAttribute('role','status'); host.append(progress);
      const rail = document.createElement('div'); rail.className = 'dod-bundle__rail'; rail.setAttribute('role','group'); rail.setAttribute('aria-label',this.text('pick_games'));
      const ordered = [...this.games.values()].filter(game=>game.id!==this.current.id && game.available).sort((a,b)=>Number(this.pending.includes(b.id))-Number(this.pending.includes(a.id)));
      ordered.forEach(game => {
        const card = document.createElement('label'); card.className = 'dod-bundle__pick';
        const checkbox = document.createElement('input'); checkbox.type = 'checkbox'; checkbox.value = game.id; checkbox.checked = this.pending.includes(game.id);
        const name = document.createElement('strong'); name.textContent = game.title;
        const prices = document.createElement('span'); prices.className = 'dod-bundle__pick-price';
        const full = document.createElement('s'); full.textContent = this.money(game.price);
        const price = document.createElement('b'); price.textContent = this.money(game.price-Math.floor(game.price*this.count/10));
        prices.append(full,price); card.append(checkbox,this.makePack(game),name,prices); rail.append(card);
        checkbox.addEventListener('change',()=>{
          if (checkbox.checked && this.pending.length<this.count) this.pending.push(game.id);
          else if (!checkbox.checked) this.pending=this.pending.filter(id=>id!==game.id);
          else checkbox.checked=false;
          update();
        });
      });
      host.append(rail);
      const controls=document.createElement('div'); controls.className='dod-bundle__rail-controls';
      const hint=document.createElement('span'); hint.textContent=this.text('swipe_hint'); controls.append(hint);
      [-1,1].forEach(direction=>{
        const button=document.createElement('button'); button.type='button'; button.textContent=direction<0?'←':'→'; button.setAttribute('aria-label',this.text(direction<0?'previous_games':'next_games'));
        button.addEventListener('click',()=>rail.scrollBy({left:direction*rail.clientWidth*.8,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'})); controls.append(button);
      });
      host.append(controls);
      const summary=document.createElement('div'); summary.className='dod-bundle__pick-total'; host.append(summary);
      const done=this.querySelector('[data-bundle-done]');
      done.onclick=()=>{
        if(this.pending.length!==this.count)return;
        const remaining=[...this.selection,...this.games.keys()].filter((id,index,ids)=>!this.pending.includes(id)&&ids.indexOf(id)===index);
        this.selection=[...this.pending,...remaining].slice(0,4);
        this.render(); this.dialog.close();
      };
      const update=()=>{
        const full=this.pending.length===this.count;
        progress.textContent=this.text(full?'selection_ready':'selection_progress',{count:this.pending.length,total:this.count,remaining:this.count-this.pending.length});
        rail.querySelectorAll('input').forEach(input=>{
          input.checked=this.pending.includes(input.value);
          input.disabled=full&&!input.checked;
          input.closest('label').classList.toggle('is-checked',input.checked);
        });
        done.disabled=!full;
        const totals=this.pending.map(id=>this.games.get(id)).reduce((sum,g)=>({original:sum.original+g.price,total:sum.total+g.price-Math.floor(g.price*this.count/10)}),{original:0,total:0});
        summary.replaceChildren();
        const label=document.createElement('span'); label.textContent=this.text('selected_total');
        const old=document.createElement('s'); old.textContent=this.money(totals.original);
        const value=document.createElement('strong'); value.textContent=this.money(totals.total);
        summary.append(label,old,value);
      };
      update(); requestAnimationFrame(()=>this.fitPacks());
    }
    async addBundle() {
      if (this.busy || this.needsCartCheck || !this.current.available || this.root?.querySelector('[data-qb-submit][aria-busy="true"]')) return;
      const selected = this.selection.slice(0,this.count).map(id => this.games.get(id));
      if (selected.length !== this.count || new Set(selected.map(game=>game.id)).size !== this.count || selected.some(game=>!game.available)) {
        this.status.textContent = this.text('unavailable'); return;
      }
      if (!window.DODGameTiers?.sync) { this.status.textContent = this.text('error'); return; }
      this.busy = true;
      this.status.textContent = '';
      this.querySelector('[data-bundle-cart-link]').hidden = true;
      const locked = [...this.root.querySelectorAll('[data-qb-submit], [data-bundle-swap], [data-qb-variant], .dod-bundle__options input')].filter(control=>!control.disabled);
      locked.forEach(control=>{control.disabled=true;});
      const release = window.DODGameTiers.begin();
      this.render();
      const drawer = document.querySelector('cart-drawer');
      const sections = drawer?.getSectionsToRender().map(section=>section.id) || ['cart-drawer','cart-icon-bubble'];
      drawer?.setActiveElement(this.submit);
      let added = false;
      try {
        const response = await fetch(this.dataset.addUrl,{
          method:'POST', headers:{'Content-Type':'application/json',Accept:'application/json'},
          body:JSON.stringify({items:selected.map(game=>({id:game.variant,quantity:1})),sections,sections_url:location.pathname})
        });
        let cart = await response.json();
        if (!response.ok || cart.status) throw new Error(typeof cart.description === 'string' ? cart.description : this.text('error'));
        added = true;
        cart = await window.DODGameTiers.sync(cart,sections);
        this.status.textContent = this.text('added');
        if (drawer && cart.sections && sections.every(id=>cart.sections[id])) {
          drawer.classList.remove('is-empty');
          drawer.renderContents(cart);
        } else location.assign(this.dataset.cartUrl);
        document.dispatchEvent(new CustomEvent('dod:bundle-added',{detail:{count:this.count}}));
      } catch (error) {
        this.status.textContent = added ? this.text('refresh_error') : error instanceof TypeError ? this.text('error') : error.message;
        if (added || error instanceof TypeError) {
          this.needsCartCheck = true;
          this.querySelector('[data-bundle-cart-link]').hidden = false;
        }
      } finally {
        locked.forEach(control=>{control.disabled=false;});
        release();
        this.busy = false;
        this.render();
      }
    }
  }
  customElements.define('dod-product-bundles',ProductBundles);
})();
